import { Formik, FormikProps } from 'formik';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';
import { IRequestGroup, REQUEST_NOTIFY_OPTION } from '../../../../lib/types';
import {
  ISendCustomRequestGroupMessageFormParams,
  SendRequestGroupMessageFormFields
} from './send-request-group-message-form-fields';
import { FormActionsRow } from '../../../_core/form/input/form-actions-row';
import { useMemo } from 'react';
import { IMultiSelectOption } from '../../../_core/input/multiselect-input.component';
import { getName } from '../../../../utils/name.utils';

interface ISendRequestMessageFormProps extends IRIFormProps<ISendCustomRequestGroupMessageFormParams> {
  clientMode: boolean;
  defaultMessage?: string;
  defaultNotify?: (REQUEST_NOTIFY_OPTION.CLIENTS | REQUEST_NOTIFY_OPTION.STAFF)[];
  forceSendAll?: boolean;
  group: IRequestGroup;
}

export const SendRequestGroupMessageForm = ({
  defaultMessage = '',
  forceSendAll,
  group,
  onBack,
  onSubmit
}: ISendRequestMessageFormProps) => {
  const replyToOptions = useMemo(() => {
    const opts: IMultiSelectOption[] = [
      { value: group.createdBy.email, label: getName(group.createdBy), secondaryLabel: group.createdBy.email },
      ...group.assignedStaff.map(
        (s) => ({ value: s.user.email, label: getName(s), secondaryLabel: s.user.email } as IMultiSelectOption)
      )
    ];
    return opts.reduce(
      (acc: IMultiSelectOption[], curr) => (acc.find((o) => o.value === curr.value) ? acc : [...acc, curr]),
      []
    );
  }, [group.assignedStaff, group.createdBy]);

  return (
    <Formik
      initialValues={
        {
          message: defaultMessage,
          replyTo: [],
          subject: forceSendAll
            ? 'You have been sent a new request'
            : "You have received a message on one of your Request's",
          assignSelf: false
        } as ISendCustomRequestGroupMessageFormParams
      }
      onSubmit={({ replyTo, ...rest }) => onSubmit({ ...rest, replyTo: replyTo.filter((v) => v) })}
      validateOnBlur={false}
    >
      {(props: FormikProps<ISendCustomRequestGroupMessageFormParams>) => (
        <SendRequestGroupMessageFormFields forceSendAll={forceSendAll} replyToOptions={replyToOptions}>
          <FormActionsRow>
            {!!onBack && <FormButton type="button" onPress={onBack} text="Cancel" variant="secondary" />}
            <FormButton loading={props.isSubmitting} disabled={props.isSubmitting} text="Send Bulk Request" />
          </FormActionsRow>
        </SendRequestGroupMessageFormFields>
      )}
    </Formik>
  );
};
